<template>
    <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Shape</title>
        <desc>Created with Sketch.</desc>
        <g id="Mobile-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group-41-Copy" transform="translate(-13.000000, -9.000000)" fill="#FBFBFB">
                <g id="Group-42">
                    <g id="Group-50">
                        <path d="M25.7932641,13.621 L30.4142641,9 L31.8282641,10.414 L27.2082641,15.036 L30.0002641,17.828 L23.0002641,17.828 L23.0002641,10.828 L25.7932641,13.621 Z M14.1142641,11.464 C14.7962641,10.782 16.8512641,10.669 16.8672641,11.029 C16.8822641,11.389 18.7182641,15.389 18.7352641,15.749 C18.7502641,16.11 17.5232641,17.339 17.1652641,17.699 C16.8092641,18.056 19.5652641,21.177 19.6162641,21.236 C19.6762641,21.288 22.7892641,24.05 23.1452641,23.694 C23.5032641,23.334 24.7302641,22.104 25.0892641,22.12 C25.4492641,22.136 29.4392641,23.977 29.7992641,23.992 C30.1592641,24.009 30.0452641,26.068 29.3642641,26.752 C28.7842641,27.334 25.7712641,29.45 20.5342641,25.671 C19.9592641,25.34 19.0492641,24.58 17.6702641,23.198 L17.6682641,23.196 L17.6652641,23.193 L17.6612641,23.189 C17.6602404,23.1883696 17.6592397,23.1877025 17.6582641,23.187 C16.2802641,21.804 15.5222641,20.892 15.1922641,20.317 C11.4222641,15.067 13.5332641,12.047 14.1142641,11.464 L14.1142641,11.464 Z"
                              id="Shape"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>


<script>
    export default {}
</script>

<style>

</style>